import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=33697318&scoped=true&"
import script from "./logistics.js?vue&type=script&lang=js&"
export * from "./logistics.js?vue&type=script&lang=js&"
import style1 from "./logistics.vue?vue&type=style&index=1&id=33697318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33697318",
  null
  
)

export default component.exports